import { EPromoInfoActions } from '../../constants/actionTypes';
import { TReduxActions } from '../../types/redux';
import { IPromoInfoState } from '../../types/redux/promoInfo';

export const defaultState = {} as IPromoInfoState;

export function promoInfoReducer(state: IPromoInfoState = defaultState, action: TReduxActions): IPromoInfoState {
  switch (action.type) {
    case EPromoInfoActions.setCommonDealDetailsModalId:
      return {
        ...state,
        commonDealDetailsModalId: action.payload,
      };

    default:
      return state;
  }
}
